export default {
  campaignBanners: [],
  campaignBannerInfos: {
    id: null,
    title: null,
    description: null,
    cta_label: null,
    image_url: null,
    destination_url: null,
    activated: null
  },
  totalPages: 1,
  socketListened: false,
  chosenBanner: {
    position: null,
    direction: null,
    hasBanner: false,
    sentManually: false
  },
  lastNews: null
}
